export enum CurrencyCode {
  DKK = 'DKK',
  SEK = 'SEK',
  NOK = 'NOK',
}

export enum FeedbackType {
  Change = 'CHANGE',
  Complaint = 'COMPLAINT',
  Feedback = 'FEEDBACK',
}

export enum ESoftCountryCode {
  DK = 'DK',
  SE = 'SE',
  NO = 'NO',
}
export enum SocialMediaPlatform {
  FACEBOOK = 'FACEBOOK',
  INSTAGRAM = 'INSTAGRAM',
  TWITTER = 'TWITTER',
  LINKEDIN = 'LINKEDIN',
}

export enum SocialMediaPlatformPreviews {
  FACEBOOK_FEED = 'Facebook feed',
  FACEBOOK_REEL = 'Facebook reel',
  INSTAGRAM_FEED = 'Instagram feed',
  INSTAGRAM_REEL = 'Instagram reel',
}

export enum Fees {
  KEY_PICKUP = 'KEY_PICKUP',
}
